export default class UpdateConversationItem {
  constructor(context) {
    this.context = context;
  }

  run({ customerId, conversationItemId, itemAttrs }) {
    if (!customerId) {
      return;
    }

    return this.context.gateways.customerHistory
      .updateConversationItem(customerId, conversationItemId, itemAttrs)
      .catch(_error => {
        // Catching the error here prevents the browser's
        // "Uncaught (in promise)" error message.
        // The gateway has already logged the specific failure.
      });
  }
}
